import { ValidationResultEnum } from "../enums/ValidationResult";
import { IValidate } from "../../interfaces/IValidate";
import { BaseValidator } from "./BaseValidator";
import { inputResult } from "../helpers/inputResult";
import { IValidationProperties } from "../../interfaces/IValidationProperties";

export class HyperLinkValidator extends BaseValidator implements IValidate {
    constructor(validationProperties: IValidationProperties) {
        super(validationProperties);
    }

    validate(value): inputResult {
        if (!this.isValidateUrl(value) && value?.length) {
            return this.handle({ inputResult: { error: `Invalid URL: ${value}`, value: (value || "") }, validationResult: ValidationResultEnum.InvalidUrl });
        }

        return super.validate(value);
    }

    private isValidateUrl(value) {
        return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
    }
}
